import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, TablePagination, Box, Typography, FormControl, InputLabel, Select, MenuItem, OutlinedInput, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Button, Chip, Stack, Tooltip, Divider, Card, CardContent } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { userAPI, merchantAPI } from '../../Api';
import PlumSvg from '../component/PlumSvg'; // Если у вас есть этот компонент

const List =  () => {
  // Состояние для данных пользователей
  const [users, setUsers] = useState([]);
  // Список всех мерчантов для выбора
  const [merchants, setMerchants] = useState([]);
  // Функции для редактирования и удаления (должны быть объявлены до useEffect, который использует editOpen)
  const [editUser, setEditUser] = useState(null);
  const [editForm, setEditForm] = useState({ name: '', tg_id:'', email: '', role: '', merchants: [] });
  const [editOpen, setEditOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  // Поиск
  const [search, setSearch] = useState('');

  // Стейт для пагинации
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await userAPI.getUsers();
        console.log(response.data)
        setUsers(response.data);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };
    fetchUsers();
  }, []);
  // Загружаем список мерчантов при открытии модалки редактирования, чтобы не грузить лишний раз
  useEffect(() => {
    const loadMerchants = async () => {
      try {
        const resp = await merchantAPI.getMerchant();
        if (resp?.data?.success) {
          setMerchants(resp.data.data || []);
        } else {
          // если бэкенд возвращает просто массив
          setMerchants(Array.isArray(resp.data) ? resp.data : []);
        }
      } catch (e) {
        console.error('Не удалось получить список мерчантов', e);
      }
    };
    if (editOpen) loadMerchants();
  }, [editOpen]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleEdit = (user) => {
    setEditUser(user);
    setEditForm({
      name: user.name,
      tg_id: user.tg_id || '',
      email: user.email,
      role: user.role,
      // user.merchants может быть массивом объектов или ObjectId-строк
      merchants: Array.isArray(user.merchants)
        ? user.merchants.map((m) => (typeof m === 'string' ? m : m?._id)).filter(Boolean)
        : []
    });
    setEditOpen(true);
  };

  const handleEditClose = () => {
    setEditOpen(false);
    setEditUser(null);
  };

  const handleEditChange = (e) => {
    setEditForm({ ...editForm, [e.target.name]: e.target.value });
  };
  const handleMerchantsChange = (e) => {
    const value = e.target.value;
    setEditForm((prev) => ({ ...prev, merchants: typeof value === 'string' ? value.split(',') : value }));
  };

  const handleEditSave = async () => {
    if (!editUser) return;
    setLoading(true);
    try {
      // Отправляем name, tg_id, email, role и merchants
      await userAPI.updateUser(editUser._id, {
        name: editForm.name,
        tg_id: editForm.tg_id,
        email: editForm.email,
        role: editForm.role,
        merchants: editForm.merchants || [],
      });
      const response = await userAPI.getUsers();
      setUsers(response.data);
      handleEditClose();
    } catch (error) {
      alert('Ошибка при обновлении пользователя');
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Удалить пользователя?')) return;
    setLoading(true);
    try {
      await userAPI.deleteUser(id);
      const response = await userAPI.getUsers();
      setUsers(response.data);
    } catch (error) {
      alert('Ошибка при удалении пользователя');
    }
    setLoading(false);
  };


  // Фильтрация по поиску
  const filtered = users.filter((u) => {
    const q = search.trim().toLowerCase();
    if (!q) return true;
    return (
      (u.name || '').toLowerCase().includes(q) ||
      (u.email || '').toLowerCase().includes(q) ||
      (u.tg_id || '').toString().toLowerCase().includes(q) ||
      (u.role || '').toLowerCase().includes(q)
    );
  });

  return (
    <Box sx={{ mt: 6, p: 2 }}>
      <Card elevation={3} sx={{ borderRadius: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2 }}>
          <Typography variant="h5" sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#683d62' }}>
            <PlumSvg /> Пользователи
          </Typography>
          <TextField
            size="small"
            placeholder="Поиск по имени, email, роли, TGID"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{ minWidth: 320 }}
          />
        </Box>
        <Divider />
        <CardContent sx={{ p: 0 }}>
      <TableContainer component={Paper} elevation={0}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold', color: '#683d62' }}>Имя</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#683d62' }}>TGID</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#683d62' }}>Email</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#683d62' }}>Роль</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#683d62' }}>Мерчанты</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#683d62' }}>Действия</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filtered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((user) => (
              <TableRow key={user._id}>
                <TableCell>{user.name}</TableCell>
                <TableCell>{user.tg_id}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>
                  <Chip label={user.role || '—'} size="small" color={user.role === 'admin' ? 'primary' : (user.role === 'ownershop' ? 'secondary' : 'default')} variant="outlined" />
                </TableCell>
                <TableCell>
                  <Stack direction="row" spacing={0.5} flexWrap="wrap">
                    {Array.isArray(user.merchants) && user.merchants.length > 0 ? (
                      user.merchants.slice(0, 3).map((m, idx) => (
                        <Chip key={idx} label={typeof m === 'string' ? m.slice(0, 6) + '…' : (m?.name || (m?._id || '').toString().slice(0,6)+'…')} size="small" />
                      ))
                    ) : (
                      <Chip label="нет" size="small" variant="outlined" />
                    )}
                    {Array.isArray(user.merchants) && user.merchants.length > 3 && (
                      <Chip label={`+${user.merchants.length - 3}`} size="small" variant="outlined" />
                    )}
                  </Stack>
                </TableCell>
                <TableCell>
                  <Tooltip title="Редактировать">
                    <IconButton onClick={() => handleEdit(user)} sx={{ color: '#683d62' }}>
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Удалить">
                    <IconButton onClick={() => handleDelete(user._id)} sx={{ color: '#683d62' }}>
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filtered.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            "& .MuiTablePagination-select": {
              color: "#683d62",
            },
            "& .MuiTablePagination-toolbar": {
              backgroundColor: "#fefcfb",
            },
            "& .MuiTablePagination-spacer": {
              display: 'none',
            },
            "& .MuiTablePagination-actions": {
              color: "#683d62",
            },
          }}
        />
      </TableContainer>
        </CardContent>
      </Card>

      {/* Модальное окно для редактирования пользователя (MUI Dialog) */}
      <Dialog open={editOpen} onClose={handleEditClose} maxWidth="sm" fullWidth>
        <DialogTitle>Редактировать пользователя</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <TextField label="Имя" name="name" value={editForm.name} onChange={handleEditChange} fullWidth />
            <TextField label="TGID" name="tg_id" value={editForm.tg_id} onChange={handleEditChange} fullWidth />
            <TextField label="Email" name="email" value={editForm.email} onChange={handleEditChange} type="email" fullWidth />
            <FormControl fullWidth>
              <InputLabel id="role-label">Роль</InputLabel>
              <Select labelId="role-label" name="role" value={editForm.role} onChange={handleEditChange} label="Роль">
                <MenuItem value="admin">admin</MenuItem>
                <MenuItem value="operator">operator</MenuItem>
                <MenuItem value="ownershop">ownershop</MenuItem>
                <MenuItem value="user">user</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="merchants-label">Мерчанты (доступ)</InputLabel>
              <Select
                labelId="merchants-label"
                multiple
                value={editForm.merchants}
                onChange={handleMerchantsChange}
                input={<OutlinedInput label="Мерчанты (доступ)" />}
                renderValue={(selected) => (
                  <Stack direction="row" spacing={0.5} flexWrap="wrap">
                    {selected.map((id) => {
                      const found = merchants.find((m) => m._id === id);
                      return <Chip key={id} label={found?.name || id} size="small" />
                    })}
                  </Stack>
                )}
              >
                {merchants.map((m) => (
                  <MenuItem key={m._id} value={m._id}>
                    {m.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditClose}>Отмена</Button>
          <Button onClick={handleEditSave} variant="contained" disabled={loading} sx={{ bgcolor: '#683d62', '&:hover': { bgcolor: '#5c3556' } }}>Сохранить</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default List;
